<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.001 16">
  <path d="M5.754.006a5.9 5.9 0 00-3.295 1.18A6.155 6.155 0 00.672 3.313 6.22 6.22 0 000 6.123a6.1 6.1 0 001.197 3.652L6 16l4.799-6.217.006-.014c1.172-1.586 1.502-3.622.904-5.584v.006C11.147 2.35 9.689.856 7.902.293A6.258 6.258 0 005.754.006zm.049.937a5.33 5.33 0 011.826.246c1.5.472 2.724 1.729 3.197 3.28.509 1.669.233 3.398-.758 4.742L6 14.48 1.934 9.21a5.169 5.169 0 01-1.01-3.088c0-1.641.779-3.206 2.084-4.184A4.99 4.99 0 015.803.943zM6 3.2c-1.765 0-3.2 1.526-3.2 3.4C2.8 8.474 4.236 10 6 10c1.765 0 3.2-1.525 3.2-3.4 0-1.874-1.435-3.4-3.2-3.4zm0 .973c1.26 0 2.285 1.089 2.285 2.427C8.285 7.94 7.26 9.027 6 9.027c-1.26 0-2.285-1.089-2.285-2.428C3.715 5.261 4.74 4.172 6 4.172z"/>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
